// validateDateOfBirth.js
import moment from 'moment';

/**
 * Validates a date of birth string.
 *
 * @param {string} dateString - The date of birth in 'DD/MM/YYYY' format.
 * @returns {string|null} - Returns an error message if validation fails; otherwise, returns null.
 */
export function validateDateOfBirth(dateString) {
  // Check if the date is provided
  if (!dateString) {
    return 'Date of Birth cannot be empty.';
  }

  // Validate the format using a regular expression (DD/MM/YYYY)
  const dateRegex = /^(0?[1-9]|[12][0-9]|3[01])\/(0?[1-9]|1[012])\/\d{4}$/;
  if (!dateRegex.test(dateString)) {
    return 'Date of birth is invalid';
  }

  // Parse the date with moment using the expected format
  const parsedDate = moment(dateString, 'DD/MM/YYYY');
  if (!parsedDate.isValid()) {
    return 'Date of birth is invalid';
  }

  // Calculate the age from the parsed date
  const age = moment().diff(parsedDate, 'years');
  if (isNaN(age) || age <= 0) {
    return 'Date of birth is invalid';
  }

  // Check if the age is below or above the allowed range
  if (age < 18) {
    return 'You must be 18 years old or over.';
  }
  if (age > 120) {
    return 'Date of birth is invalid';
  }

  // If all checks pass, return null indicating no errors
  return null;
}
